import { FEATURE_KEYS } from "./plans";

export const ACCESS_RULES = {
    DASHBOARD_OPERATIONAL: { feature: FEATURE_KEYS.DASHBOARD_OPERATIONAL },
    DASHBOARD_MANAGER: { feature: FEATURE_KEYS.DASHBOARD_MANAGER, permission: "dashboards_manager_view" },
    DASHBOARD_FINANCIAL: { feature: FEATURE_KEYS.DASHBOARD_FINANCIAL, permission: "dashboards_financial_view" },
    TEAM_EMPLOYEES: { feature: FEATURE_KEYS.TEAM_MANAGEMENT, permission: "employees_manage" },
    TEAM_ROLES: { feature: FEATURE_KEYS.TEAM_MANAGEMENT, permission: "admin_roles" },
    MEMBER_MEMBERSHIPS: { feature: FEATURE_KEYS.MEMBER_MEMBERSHIPS_TAB, permission: "admin_memberships" },
    MEMBER_PROFILE_FINANCIAL: { feature: FEATURE_KEYS.MEMBER_FINANCIAL_TAB, permissionsAny: ["financial_cashflow", "financial_cashier"] },
    MEMBER_PROFILE_MEMBERSHIPS: { feature: FEATURE_KEYS.MEMBER_MEMBERSHIPS_TAB, permissionsAny: ["admin_memberships", "financial_cashier", "members_manage"] },
    SALES_POINT: { feature: FEATURE_KEYS.SALES_POINT, permission: "financial_cashier" },
    SALES_CATALOG: { feature: FEATURE_KEYS.SALES_POINT, permission: "admin_catalog" },
    DEBT_PAYMENT: { feature: FEATURE_KEYS.DEBT_PAYMENT, permission: "financial_cashier" },
    FINANCIAL_CONFIG: { feature: FEATURE_KEYS.FINANCIAL_MODULE, permission: "financial_config" },
    FINANCIAL_ACQUIRERS: { feature: FEATURE_KEYS.FINANCIAL_MODULE, permission: "financial_acquirers" },
    FINANCIAL_CASHIER: { feature: FEATURE_KEYS.FINANCIAL_MODULE, permission: "financial_cashier" },
    FINANCIAL_REPORTS: { feature: FEATURE_KEYS.FINANCIAL_MODULE, permission: "financial_cashflow" },
    CLASS_MANAGEMENT: { feature: FEATURE_KEYS.CLASS_MANAGEMENT, permission: "admin_classes" },
    GRADE_MANAGEMENT: { feature: FEATURE_KEYS.CLASS_MANAGEMENT, permission: "grade_manage" },
    MEMBERS: { feature: FEATURE_KEYS.MEMBERS_MODULE, permission: "members_manage" },
    CRM: { feature: FEATURE_KEYS.CRM_MODULE, permission: "members_manage" },
    PERFORMANCE: { feature: FEATURE_KEYS.PERFORMANCE_MODULE, permission: "performance_view" },
    GOALS: { feature: FEATURE_KEYS.GOALS_MODULE, permissionsAny: ["goals_view", "goals_manage"] },
    PLANNING: { feature: FEATURE_KEYS.PLANNING_MODULE, permission: "methodology_planning" },
    GAMIFICATION: { feature: FEATURE_KEYS.GAMIFICATION, permission: "settings_gamification" },
    AUTOMATIONS: { feature: FEATURE_KEYS.AUTOMATIONS, permission: "management_automations" },
    INTEGRATIONS: { feature: FEATURE_KEYS.INTEGRATIONS, permission: "management_integrations" },
    BUSINESS_RULES: { feature: FEATURE_KEYS.BUSINESS_RULES, permission: "management_automations" },
    KIOSK: { feature: FEATURE_KEYS.KIOSK },
    MEDIA: { feature: FEATURE_KEYS.MEDIA },
    COMPANY_SETTINGS: { permission: "settings_company_manage" },
    IMPORT_MEMBERS: { feature: FEATURE_KEYS.TEAM_MANAGEMENT, permission: "settings_import" },
    ACTIVITIES: { permission: "admin_activities" },
    LEVELS: { permission: "management_evaluation_levels" },
    EVENTS: { permission: "admin_events" },
    EVALUATION: { permission: "management_evaluation_run" },
    TRAINING_WORKOUTS: { feature: FEATURE_KEYS.WORKOUT_CREATION, permission: "management_training_manage" },
    PORTFOLIO: { feature: FEATURE_KEYS.CRM_MODULE, permission: "admin_portfolio" },
    AUDIT_LOGS: { feature: FEATURE_KEYS.CRM_MODULE, permission: "management_audit_log" },
    ACTIVITY_MEMBERS: { feature: FEATURE_KEYS.CRM_MODULE, permission: "members_manage" },
    TRIALS: { feature: FEATURE_KEYS.CRM_MODULE, permission: "members_manage" },
    CANCELLATIONS: { feature: FEATURE_KEYS.CRM_MODULE, permission: "members_manage" },
};

export const PAGE_ACCESS_MAP = {
    "/dashboard": ACCESS_RULES.DASHBOARD_OPERATIONAL,
    "/dashboard/gerencial": ACCESS_RULES.DASHBOARD_MANAGER,
    "/dashboard/financeiro": ACCESS_RULES.DASHBOARD_FINANCIAL,
    "/admin/employees": ACCESS_RULES.TEAM_EMPLOYEES,
    "/admin/roles": ACCESS_RULES.TEAM_ROLES,
    "/admin/activities": ACCESS_RULES.ACTIVITIES,
    "/admin/events": ACCESS_RULES.EVENTS,
    "/admin/levels": ACCESS_RULES.LEVELS,
    "/admin/memberships": ACCESS_RULES.MEMBER_MEMBERSHIPS,
    "/admin/services": ACCESS_RULES.SALES_CATALOG,
    "/admin/bank-accounts": ACCESS_RULES.FINANCIAL_CONFIG,
    "/admin/acquirers": ACCESS_RULES.FINANCIAL_ACQUIRERS,
    "/admin/financial-categories": ACCESS_RULES.FINANCIAL_CONFIG,
    "/admin/portfolio": ACCESS_RULES.PORTFOLIO,
    "/admin/audit-logs": ACCESS_RULES.AUDIT_LOGS,
    "/management/classes": ACCESS_RULES.CLASS_MANAGEMENT,
    "/management/trials": ACCESS_RULES.TRIALS,
    "/management/activity-members": ACCESS_RULES.ACTIVITY_MEMBERS,
    "/management/performance": ACCESS_RULES.PERFORMANCE,
    "/management/goals": ACCESS_RULES.GOALS,
    "/management/cancellations": ACCESS_RULES.CANCELLATIONS,
    "/members": ACCESS_RULES.MEMBERS,
    "/members/:id": ACCESS_RULES.MEMBERS,
    "/members/:id/sales-point": ACCESS_RULES.SALES_POINT,
    "/members/:id/debt-payment": ACCESS_RULES.DEBT_PAYMENT,
    "/crm": ACCESS_RULES.CRM,
    "/grade": ACCESS_RULES.GRADE_MANAGEMENT,
    "/grade/enrollment": ACCESS_RULES.GRADE_MANAGEMENT,
    "/grade/planning": ACCESS_RULES.PLANNING,
    "/evaluation": ACCESS_RULES.EVALUATION,
    "/training/workouts": ACCESS_RULES.TRAINING_WORKOUTS,
    "/sales": ACCESS_RULES.SALES_POINT,
    "/financial/cashier": ACCESS_RULES.FINANCIAL_CASHIER,
    "/financial/receivables": ACCESS_RULES.FINANCIAL_REPORTS,
    "/financial/payables": ACCESS_RULES.FINANCIAL_REPORTS,
    "/financial/cash-flow": ACCESS_RULES.FINANCIAL_REPORTS,
    "/financial/dre": ACCESS_RULES.FINANCIAL_REPORTS,
    "/financial/sales": ACCESS_RULES.FINANCIAL_REPORTS,
    "/settings/company": ACCESS_RULES.COMPANY_SETTINGS,
    "/settings/gamification": ACCESS_RULES.GAMIFICATION,
    "/settings/automations": ACCESS_RULES.AUTOMATIONS,
    "/settings/integrations": ACCESS_RULES.INTEGRATIONS,
    "/settings/import-members": ACCESS_RULES.IMPORT_MEMBERS,
    "/settings/business-rules": ACCESS_RULES.BUSINESS_RULES,
    "/kiosk": ACCESS_RULES.KIOSK,
    "/kiosk/evaluation": ACCESS_RULES.KIOSK,
    "/kiosk/tv": ACCESS_RULES.KIOSK,
    "/kiosk/professors": ACCESS_RULES.KIOSK,
    "/kiosk/media": ACCESS_RULES.MEDIA,
};

export const ACTION_ACCESS_MAP = {
    MEMBER_NEW_SALE: ACCESS_RULES.SALES_POINT,
    MEMBER_PAY_DEBT: ACCESS_RULES.DEBT_PAYMENT,
    MEMBER_FINANCIAL_TAB: ACCESS_RULES.MEMBER_PROFILE_FINANCIAL,
    MEMBER_MEMBERSHIPS_TAB: ACCESS_RULES.MEMBER_PROFILE_MEMBERSHIPS,
};
